module.exports = __webpack_public_path__ + "static/media/Maven_6510.0853004c.jpg";